<form (ngSubmit)="onAddTimeExpression()" [formGroup]="form">
  <table class="table va-middle table-striped" id="triggerSignalExpressions">
    <thead>
      <tr>
        <th translate>Correlation</th>
        <th translate>Interval</th>
        <th translate>Time</th>
        <th translate>Day of Week</th>
        <th translate>Day of Month</th>
        <th class="text-right" translate>Action</th>
      </tr>
    </thead>
    <tbody>

      @for (expr of triggerTimeExpressions; track expr; let index = $index) {
        <tr [attr.data-index]="index">
          <td>@if (index > 0) {
            <span>{{'OR'}}</span>
          }</td>
          @if (expr.triggerTimeCondition) {
            <td [innerText]="expr.triggerTimeCondition.type"></td>
          }
          @if (expr.triggerTimeCondition) {
            <td [innerText]="expr.triggerTimeCondition.time | date: 'HH:mm'"></td>
          }
          @if (expr.triggerTimeCondition) {
            <td [innerText]="getDayOfWeekValue(expr.triggerTimeCondition)"></td>
          }
          @if (expr.triggerTimeCondition) {
            <td [innerText]="getDayOfMonthValue(expr.triggerTimeCondition)"></td>
          }
          <td class="text-right">
            <button (click)="onRemoveTimeExpression(index, expr)" [disabled]="!isAdminOrHigher"
              class="btn btn-sm btn-outline-danger" title="{{ 'Delete time condition' | translate}}"
              type="button">
              <span class="fa-solid fa-trash"></span>
            </button>
          </td>
        </tr>
      }
      <tr>
        <td></td>
        <td>
          <ng-select (change)="onTimeExpressionIntervalChange($event)"
            (focusout)="onFocusOut()"
            [disabled]="!isAdminOrHigher" [items]="timeIntervalTypes"
            [ngClass]="{ 'is-invalid':formControls.timeInterval.errors }" bindLabel="value" bindValue="key"
            formControlName="timeInterval" id="timeInterval">
          </ng-select>
          <input [hidden]="true" [ngClass]="{ 'is-invalid': formControls.timeInterval.errors }" class="form-control"
            id="selectedTimeInterval"
            type="text">
          </td>
          <td>
            <ngb-timepicker (focusout)="onFocusOut()" formControlName="time"></ngb-timepicker>
          </td>
          <td>
            @if (selectedTimeIntervalType==='WEEKLY') {
              <ng-select (click)="onFocusOut()" (focusout)="onFocusOut()"
                [disabled]="!isAdminOrHigher" [items]="translatedDaysOfWeek"
                [ngClass]="{ 'is-invalid':formControls.dayOfWeek.errors }" bindLabel="value" bindValue="key"
                formControlName="dayOfWeek" id="dayOfWeek">
              </ng-select>
            }
            <input [hidden]="true" [ngClass]="{ 'is-invalid': formControls.dayOfWeek.errors }" class="form-control"
              id="selectedDayOfWeek"
              type="text">
            </td>

            <td>
              @if (selectedTimeIntervalType==='MONTHLY') {
                <input (focusout)="onFocusOut()"
                  [disabled]="!isAdminOrHigher"
                  [ngClass]="{ 'is-invalid': formControls.dayOfMonth.errors }" class="form-control"
                  formControlName="dayOfMonth"
                  id="dayOfMonth" name="dayOfMonth" type="text">
              }
            </td>
            <td class="text-right">
              <button [disabled]="addTriggerTimeExpressionDisabled()" class="btn btn-sm btn-primary"
                title="{{ 'Add expression' | translate }}" type="submit">
                <span class="fa-solid fa-plus"></span>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </form>
